module.exports = __webpack_public_path__ + "media/event_more-wolves.1fc67891.mp3";